import { TKey } from '~/src/dash/publicaUI';

export enum EActiveFilter {
  SHOW_ALL = 0,
  INACTIVE,
  ACTIVE,
}

interface IStatusOption {
  labelTKey: TKey;
  value: number;
  messageTKey: TKey;
}

export const statuses: IStatusOption[] = [
  { labelTKey: 'Active', value: EActiveFilter.ACTIVE, messageTKey: 'ShowingActiveOnly' },
  { labelTKey: 'Inactive', value: EActiveFilter.INACTIVE, messageTKey: 'ShowingInactiveOnly' },
  { labelTKey: 'ShowAll', value: EActiveFilter.SHOW_ALL, messageTKey: 'ShowingAll' },
];
